(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GrowthDetailController', GrowthDetailController);

    GrowthDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Growth'];

    function GrowthDetailController($scope, $rootScope, $stateParams, previousState, entity, Growth) {
        var vm = this;

        vm.growth = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:growthUpdate', function(event, result) {
            vm.growth = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
